import { IUserStatus, EPillarType } from '../models';
import translate from './translate';

export * from './get-query-param';
export * from './notification-formatters';
export * from './get-image-source';
export * from './pluralize-if-necessary';
export * from './convertBlobSizeToMegaByte';
export * from './challengeStateTranslator';
export * from './getFileTypeFromExtension';
export * from './onClickEventHelpers';
export * from './past-winners-period';
export * from './getWordCount';
export * from './calculateTimeLeft';
export * from './mapRecordingEnumType';
export * from './convertUnderlineToSpace';
export * from './salaryRangeConverter';
export * from './formatStringToDate';
export * from './calculateAge';
export * from './roundAndDropTrailingZeros';
export * from './camelToSpace';
export * from './convertImageIntoBase64';
export * from './stringToCode';
export * from './getResourceCoverImage';
export * from './baseline-assessment';
export * from './reverseDateFormat';
export * from './checkIfDevEnvironment';
export * from './checkDomainIfAdmin';
export * from './capitalizeFirstLetter';
export * from './convertMinutesIntoHours';
export * from './convertUnderlineToSpace';
export * from './getRandomNumber';
export * from './isEventApplicable';
export * from './downloadDocument';
export * from './objectToStringFormat';

export { translate };

export const userStatuses: IUserStatus[] = [
  { value: 'Active', label: translate('active') },
  { value: 'Invited', label: translate('invited') },
];

export const pillarTitle = {
  [EPillarType.PERSONAL_DEVELOPMENT]: translate('personalDevelopment'),
  [EPillarType.COMMUNICATION]: translate('communication'),
  [EPillarType.ACTIVE_CITIZENSHIP]: translate('activeCitizenship'),
  [EPillarType.CAREER_READINESS]: translate('careerReadiness'),
  [EPillarType.LEARNING]: translate('learning'),
};

export const billingfilterByStatusOptions = [
  { param: '', title: 'All' },
  { param: 'paid', title: 'Paid' },
  { param: 'failed', title: 'Failed' },
  { param: 'cancelled', title: 'Cancelled' },
];

export function getFileNameFromKey(key: string) {
  return key.split('-').slice(2).join('');
}

export const genderOptions = [
  { value: 'MALE', label: 'Male' },
  { value: 'FEMALE', label: 'Female' },
  {
    value: 'OTHER',
    label: 'Other',
  },
  {
    value: null,
    label: 'Null',
  },
];

export function getStudentStatusTagType(status: string) {
  switch (status.toLowerCase()) {
    case 'active':
      return 'green';
    case 'expiring':
      return 'orange';
    case 'expired':
      return 'red';
    case 'invited':
    default:
      return 'blue';
  }
}

export function getBaselineAttemptText(attempt: number) {
  let attempts = '';
  if (attempt === 1) attempts = '1st';
  else if (attempt === 2) attempts = '2nd';
  else if (attempt === 3) attempts = '3rd';
  else if (attempt > 3) attempts = attempt + 'th';

  return attempt > 0 ? attempts + ' Attempt Complete' : 'Yet to take';
}

export const studentStatusOptions = [
  { value: 'Invited', label: 'Invited' },
  { value: 'Active', label: 'Active' },
  { value: 'Expiring', label: 'Expiring' },
  { value: 'Expired', label: 'Expired' },
];

export const baselineAttemptOptions = [
  { value: '0', label: 'Yet to take' },
  { value: '1', label: 'First Attempt' },
  { value: '2', label: 'Second Attempt' },
  { value: '3', label: 'Third Attempt' },
];

export const studentCreditOptions = [
  { value: '1', label: '1 Credit (1 Year)' },
  { value: '2', label: '2 Credits (2 Years)' },
  { value: '3', label: '3 Credits (3 Years)' },
  { value: '4', label: '4 Credits (4 Years)' },
];

export const rankPeriods = [
  {
    id: 'week',
    label: 'Weekly',
  },
  {
    id: 'month',
    label: 'Monthly',
  },
  {
    id: 'allTime',
    label: 'All time',
  },
] as const;

export const translationLabel = {
  eng: 'English',
  es: 'Spanish',
  ar: 'Arabic',
  zh: 'Chinese',
  de: 'Deutsch',
  ja: 'Japanese',
  pt: 'Portuguese',
};

export const ignoreAttribute = {
  contrast: {
    'data-uw-ignore-s3': 'true',
  },
};
